import { FieldTitle } from '../shadcn/field';

export const Info = ({ children }: React.PropsWithChildren) => (
  <FieldTitle className="block mb-xs text-label-small font-semibold text-content-dark">{children}</FieldTitle>
);
